import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Slider } from '../ui/slider';
import { useUrlPhoto } from './PhotosEmplacements';
import { ApercuDiapo } from './ApercuDiapo';

// Recadrage d'une photo : on clique sur la partie intéressante, on zoome, l'aperçu de la diapo se met à jour
export const RecadrageDialog = ({ ouvert, api, cle, numero, valeur, refs, cadrages, index, onValider, onClose }) => {
  const [c, setC] = useState({ x: 0.5, y: 0.5, z: 1 });
  useEffect(() => { if (ouvert) setC(cadrages[index] || { x: 0.5, y: 0.5, z: 1 }); }, [ouvert, index]); // eslint-disable-line react-hooks/exhaustive-deps
  const url = useUrlPhoto(ouvert ? refs[index] : null);
  const essai = refs.map((_, i) => (i === index ? c : cadrages[i] || null));
  const viser = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    setC({ ...c, x: Math.round(((e.clientX - r.left) / r.width) * 100) / 100, y: Math.round(((e.clientY - r.top) / r.height) * 100) / 100 });
  };
  return (
    <Dialog open={ouvert} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-5xl" data-testid="recadrage-dialog">
        <DialogHeader>
          <DialogTitle>Recadrer la photo {index + 1}</DialogTitle>
          <DialogDescription>Cliquez sur la partie de la photo à garder, puis zoomez si besoin. L'aperçu à droite montre le résultat sur la diapo.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 md:grid-cols-2">
          <div>
            <div className="relative inline-block cursor-crosshair overflow-hidden rounded-lg bg-slate-100" onClick={viser} data-testid="recadrage-photo">
              {url && <img src={url} alt="" className="block max-h-[55vh] w-auto max-w-full select-none" draggable={false} />}
              <span className="pointer-events-none absolute h-6 w-6 -translate-x-1/2 -translate-y-1/2 rounded-full border-[3px] border-white bg-[#8DC63F]/70 shadow"
                style={{ left: `${c.x * 100}%`, top: `${c.y * 100}%` }} />
            </div>
            <label className="mt-4 block text-xs font-medium text-slate-600">Zoom : ×{c.z.toFixed(1)}
              <Slider min={1} max={3} step={0.1} value={[c.z]} onValueChange={([z]) => setC({ ...c, z })} className="mt-2" data-testid="recadrage-zoom" />
            </label>
          </div>
          <ApercuDiapo api={api} cle={cle} numero={numero} valeur={valeur} refs={refs} cadrages={essai} />
        </div>
        <DialogFooter className="gap-2">
          <button type="button" onClick={() => onValider(null)} data-testid="recadrage-reinitialiser" className="rounded-full px-4 py-2 text-sm text-slate-600 hover:bg-slate-100">Cadrage automatique</button>
          <button type="button" onClick={() => onValider(c)} data-testid="recadrage-valider"
            className="rounded-full bg-[#0F172A] px-5 py-2 text-sm font-bold text-white hover:bg-[#1E293B]">Valider le cadrage</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
